// import React from 'react';



// export const ProductFeaturesDetails = ({ data }) => {
//     return (
//         <div className="container">
//             {data.map((data, index) => (
//                 <div key={index} className="img-details-container">
//                     {/* Title */}
//                     <h2>{data.tittle}</h2>

//                     {/* Features List */}
//                     <div className="featureList">
//                         <h3>Features</h3>
//                         <div className="listdata">
//                             <ul>
//                                 {data.feature.map((feature, idx) => (
//                                     <li key={idx}>
//                                         <strong>{data.srtrongtitle[idx]}:</strong> {feature}
//                                     </li>
//                                 ))}
//                             </ul>
//                         </div>
//                         {/* Product Images */}
//                         <div className="Bottomside">
//                             {data.images.map((image, imgIdx) => (
//                                 <img key={imgIdx} src={image} alt={`Feature Image ${imgIdx + 1}`} />
//                             ))}
//                         </div>

//                     </div>



//                     {/* Side Images */}
//                     <div className="rightside">
//                         {data.SideImages.map((sideImage, sideImgIdx) => (
//                             <img key={sideImgIdx} src={sideImage} alt={`Side Image ${sideImgIdx + 1}`} />
//                         ))}
//                     </div>
//                 </div>
//             ))}
//         </div>
//     );
// };



import React from 'react';

export const ProductFeaturesDetails = ({ data }) => {
  return (
    <div className="container">
      {data.map((item, index) => (
        <div key={index} className="img-details-container">
          {/* Left Section: Features and Product Images */}
          <div className="left-section">
            {/* Title */}
            {/* <h2>{item.tittle}</h2> */}

            {/* Features List */}
            <div className="featureList">
              <h3 className="underline">Features</h3>
              <div className="listdata">
                <ul>
                  {item.feature.map((feature, idx) => (
                    <li key={idx}>
                      <strong>{item.srtrongtitle[idx]}:</strong> {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Product Images */}
            <div className="Bottomside">
              {item.images.map((image, imgIdx) => (
                <img key={imgIdx} src={image} alt={`Feature Image ${imgIdx + 1}`} />
              ))}
            </div>
          </div>

          {/* Right Section: Side Images */}
          <div className="rightside">
            {item.SideImages.map((sideImage, sideImgIdx) => (
              <img key={sideImgIdx} src={sideImage} alt={`Side Image ${sideImgIdx + 1}`} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

